/**
 * On-page science section (snippets/pepnow-product-science.liquid).
 * Links pointing at #pepnow-science… scroll down to the study summaries instead of navigating,
 * and the closing "Choose your plan" button scrolls back up to the buy box.
 */
(() => {
  if (!document.getElementById('pepnow-science')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const scrollToElement = (element) => {
    const header = document.querySelector('#header-component, .header');
    const offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    const top = element.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    const buy = event.target.closest('[data-pn-sci-buy]');
    if (buy) {
      const buyBox =
        document.querySelector('.pn-sub:not([hidden])') ||
        document.querySelector('[id^="ProductInformation-"]') ||
        document.getElementById('MainContent');
      if (!buyBox) return;
      event.preventDefault();
      scrollToElement(buyBox);
      return;
    }

    const link = event.target.closest('a[href*="#pepnow-science"]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    scrollToElement(target);
    history.replaceState(null, '', link.hash);
  });
})();
